import { Component, OnInit } from '@angular/core';
import { PasswordForgotComponent } from '../shared/popups/password-forgot/password-forgot.component';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-link-expired',
  templateUrl: './link-expired.component.html',
  styleUrls: ['./link-expired.component.css']
})
export class LinkExpiredComponent implements OnInit {

  constructor(public dialog: MatDialog) { }

  ngOnInit() {
  }
  ResendEmail(): void {
    const data = { title: 'Resend Email ?', type: 'resend_email' };
    const dialogRef = this.dialog.open(PasswordForgotComponent, {
      data, width: '400px',
    });
  }
}
